exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.pay-in__body[data-v-0d4bedf4] {\n  min-height: 11.25rem;\n}\n.pay-in__review-label[data-v-0d4bedf4] {\n  display: block;\n  color: #222c3c;\n  font-size: 0.8rem;\n}\n.pay-in__summary-row--total[data-v-0d4bedf4] {\n  padding: 0.5rem 0;\n  background: #f5f8fa;\n}\n.pay-in__summary-totals[data-v-0d4bedf4] {\n  border: 1px solid #6ac951;\n  border-radius: 0.25rem;\n  overflow: hidden;\n}\n.pay-in__green[data-v-0d4bedf4] {\n  color: #6ac951;\n}\n.pay-in__invoice-dropdown-label[data-v-0d4bedf4] {\n  color: #222c3c;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n.pay-in__invoice-select[data-v-0d4bedf4] {\n  width: 300px;\n  max-width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0d4bedf4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationPayIn/Step3Summary.vue
// module id = 2006
// module chunks = 0